import {Alert, Button, ButtonBorder, Div, HeaderBack, Label} from 'components';
import {Ecolors, stringApp} from 'constant';
import React, {useCallback, useEffect, useState} from 'react';
import {FlatList} from 'react-native-gesture-handler';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {useDispatch} from 'react-redux';
import {getInfo} from 'reducer/authen';
import {getStatusEditProfile} from 'reducer/authen/selector';
import {apiAuth, navigate} from 'services';
import {useAppSelector} from 'store/hooks';
import {parseMultilanguage} from 'utils';
const size = 18;

function II(p: {
  data: any;
  prefix: any;
  value: any;
  onSelect: (t: any) => void;
}) {
  const {data, onSelect, value, prefix} = p;
  const stateData = data[prefix];
  return (
    <Div
      flexDirection="row"
      alignItems="center"
      flex={1}
      justifyContent="flex-start">
      <Button
        onPress={() => {
          onSelect(prefix);
        }}
        paddingVertical={10}
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'flex-start'}>
        <Div
          widthHeight={size}
          borderWidth={1}
          marginRight={10}
          borderRadius={size}
          borderColor={prefix == value ? Ecolors.redColor : Ecolors.mainColor}
          alignItems={'center'}
          justifyContent={'center'}>
          <Div
            widthHeight={size - 5}
            borderRadius={size - 5}
            backgroundColor={
              prefix == value ? Ecolors.redColor : Ecolors.whiteColor
            }
          />
        </Div>
        <Label size={14} multilanguage={false} fontWeight="bold">
          {stateData.name}
        </Label>
      </Button>
    </Div>
  );
}

function QQ(p: {
  data: any;
  control: any;
  onSelect: (t: any) => void;
  I18nState: 'vi' | 'en';
}) {
  const {data, onSelect, I18nState, control} = p;
  return (
    <Div paddingHorizontal={12}>
      <Label multilanguage={false}>{data.content}</Label>
      {data.data.map((item: any, index: number) => {
        return (
          <Div
            paddingVertical={10}
            key={index}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-start'}>
            <Button
              onPress={() => {
                onSelect(item);
              }}
              widthHeight={size}
              borderWidth={1}
              marginRight={10}
              borderRadius={size}
              borderColor={
                control == item.id ? Ecolors.redColor : Ecolors.mainColor
              }
              alignItems={'center'}
              justifyContent={'center'}>
              <Div
                widthHeight={size - 5}
                borderRadius={size - 5}
                backgroundColor={
                  control == item.id ? Ecolors.redColor : Ecolors.whiteColor
                }
              />
            </Button>
            <Div flex={1}>
              <Button
                onPress={() => {
                  onSelect(item);
                }}>
                <Label multilanguage={false} size={14}>
                  {item.name}
                </Label>
              </Button>
            </Div>
          </Div>
        );
      })}
    </Div>
  );
}

function RiskConfirmModal() {
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const [listSelect, setListSelect] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();
  const isEdit = useAppSelector(state => getStatusEditProfile(state));

  useEffect(() => {
    let objjj = {};
    stringApp?.[parseMultilanguage(`component.riskAssessment`)].map(
      (item: any, index: number) => {
        objjj[item.id] = item.data[0].id;
      },
    );
    setListSelect(
      {...objjj, dividend: 'REINVESTMENT', ...currentUser?.riskInfo} || {},
    );
    return () => {};
  }, [currentUser]);

  const confirm = async () => {
    try {
      setLoading(true);
      const res = await apiAuth.riskUpdate(listSelect);
      if (res.status == 200) {
        dispatch(getInfo({}));
        Alert.show({
          type: 2,
          content: 'alert.capnhatmucdoruirothanhcong',
          onConfirm: () => {
            navigate('AccountVerifyScreen');
          },
        });
        return;
      }
    } catch (error: any) {
      Alert.showError({
        multilanguage: false,
        content: I18nState == 'vi' ? error.message : error.messageEn,
        onPress: () => {
          navigate('AccountVerifyScreen');
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const renderItem = (p: {item: any; index: number}) => {
    if (p.item.id == 'dividend') {
      return <></>;
    }
    return (
      <QQ
        control={listSelect[p.item.id] || {}}
        data={p.item}
        I18nState={I18nState}
        onSelect={(s: any) => {
          if (!isEdit) {
            return;
          }
          setListSelect(t => {
            return {
              ...t,
              [p.item.id]: s.id,
            };
          });
        }}
      />
    );
  };

  const ItemSeparatorComponent = useCallback(() => {
    return <Div widthHeight={10} />;
  }, []);

  const ListHeaderComponent = useCallback(() => {
    return <Div widthHeight={10} />;
  }, []);

  const ListFooterComponent = () => {
    return (
      <Div paddingHorizontal={12} marginTop={12}>
        {/* <Label fontWeight="bold">{`accountverify.chinhsachcotuc`}</Label>
        <Label
          size={14}
          marginVertical={12}>{`accountverify.dividendcontent`}</Label>
        <Div
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between">
          <II
            data={stringApp?.[parseMultilanguage(`component.Dividend`)]}
            prefix={'PAID_TO_INVESTOR'}
            value={listSelect?.dividend}
            onSelect={res => {
              if (!isEdit) {
                return;
              }
              setListSelect(t => {
                return {...t, dividend: res};
              });
            }}
          />
          <II
            data={stringApp?.[parseMultilanguage(`component.Dividend`)]}
            prefix={'REINVESTMENT'}
            value={listSelect?.dividend}
            onSelect={res => {
              if (!isEdit) {
                return;
              }
              setListSelect(t => {
                return {...t, dividend: res};
              });
            }}
          />
        </Div> */}
        <Div widthHeight={100} />
      </Div>
    );
  };

  const keyExtractor = (item: any, index: number) => `key${item.id}`;

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack type={2} title={`accountverify.danhgiamucdoruiro`} />
      <FlatList
        data={stringApp?.[parseMultilanguage(`component.riskAssessment`)]}
        extraData={[
          stringApp?.[parseMultilanguage(`component.riskAssessment`)],
        ]}
        renderItem={renderItem}
        ListHeaderComponent={ListHeaderComponent}
        ListFooterComponent={ListFooterComponent}
        ItemSeparatorComponent={ItemSeparatorComponent}
        keyExtractor={keyExtractor}
      />
      {isEdit && (
        <Div
          marginBottom={insets.bottom + 15}
          width={'100%'}
          alignItems={'center'}
          justifyContent={'center'}>
          <ButtonBorder
            width={343}
            loading={loading}
            onPress={() => confirm()}
            title={`accountverify.guithongtin`}
          />
        </Div>
      )}
    </Div>
  );
}

export default React.memo(RiskConfirmModal);
